import { Component, HostBinding } from '@angular/core';
import { BreezeValidationMessagePipe } from './breeze-validation-message.pipe';
import { FormErrorBaseComponent } from './form-error-base.component';

@Component({
  selector: 'breeze-form-error',
  standalone: true,
  imports: [BreezeValidationMessagePipe],
  template: `@if (invalid && dirty) {
    {{ errors | breezeValidationMessage }}
  }`,
  styles: [
    `
      :host {
        display: inline-block;
      }
    `
  ]
})
export class BreezeFormErrorComponent extends FormErrorBaseComponent {
  @HostBinding('class.breeze-form-error--invalid') get invalidCss() {
    return this.invalid;
  }
  @HostBinding('class.breeze-form-error--valid') get validCss() {
    return !this.invalid;
  }
}
